import { render, staticRenderFns } from "./Matrix3RealizationScopesSummary.vue?vue&type=template&id=32590a7b&scoped=true"
import script from "./Matrix3RealizationScopesSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./Matrix3RealizationScopesSummary.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Matrix3RealizationScopesSummary.vue?vue&type=style&index=0&id=32590a7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32590a7b",
  null
  
)

export default component.exports